import { BridgeType } from '../context';

export const useStoreReview = (bridge: BridgeType) => {
  const handleStoreReview = async () => {
    if (!bridge.isWebViewBridgeAvailable) return;

    try {
      const hasAction = await bridge.storeReviewHasAction();
      const isAvailable = await bridge.storeReviewIsAvailableAsync();

      if (hasAction && isAvailable) {
        await bridge.storeReviewRequestReview();
      }
    } catch (error) {
      console.error('Store Review Error:', error);
    }
  };

  return { handleStoreReview };
};
